namespace TabAurous.Production {
    export interface WorkOrderRow {
        TransId?: number;
        TransDate?: string;
        DepartmentId?: number;
        VoucherTypeId?: number;
        VoucherNo?: string;
        UserId?: number;
        Username?: string;
        EmployeeId?: number;
        CompanyId?: number;
        FinancialYearId?: number;
        SelectDetails?: WorkOrderItemsRow[];
        ItemDetails?: WorkOrderItemsRow[];
        Pieces?: number;
        NoofBags?: number;
    }

    export namespace WorkOrderRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Production.WorkOrder';
        export const deletePermission = 'Production:WorkOrder:Delete';
        export const insertPermission = 'Production:WorkOrder:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:WorkOrder:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            DepartmentId = "DepartmentId",
            VoucherTypeId = "VoucherTypeId",
            VoucherNo = "VoucherNo",
            UserId = "UserId",
            Username = "Username",
            EmployeeId = "EmployeeId",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            SelectDetails = "SelectDetails",
            ItemDetails = "ItemDetails",
            Pieces = "Pieces",
            NoofBags = "NoofBags"
        }
    }
}
